<div
  id="modern-table-container"
  class="modern-table"
  [ngClass]="{ 'read-only': isReadyOnly(), fullscreen: isFullScreenMode }"
>
  <div class="table-controls">
    <div class="table-controls-left">
      @if (!isTableLocked) {
      <div
        class="icon-text-action"
        (click)="newRow()"
        [ngClass]="{ hidden: isReadyOnly() }"
      >
        <div class="icon add-circle" title="Add New Row"></div>
        <span class="text">{{ "taxReturns.add-row" | transloco }}</span>
      </div>
      }
    </div>
    <div class="table-controls-right">
      @if (!debugMode && isVisible) {
      <modern-table-view-controls
        [questions]="columnOrdering"
        [parentTableQuestion]="subGroup.question"
        [taxReturnId]="taxReturnId"
      ></modern-table-view-controls>
      }

      <div
        class="ui button primary outlined icon-button"
        (click)="openTableFilterModal()"
      >
        <div class="icon filter" title="Filter rows"></div>
        <span class="text">{{ "taxReturns.filter" | transloco }}</span>
      </div>

      @if (isFullScreenMode && !sideOpen) {
      <div class="ui button primary icon-button" (click)="handleSideOpen(true)">
        <span class="text">{{ "taxReturns.show-side-bar" | transloco }}</span>
      </div>
      }

      <div class="icon-text-action" (click)="doToggleFullScreen()">
        @if (!isFullScreenMode && !hideFullScreen) {
        <span class="text">{{ "taxReturns.full-screen" | transloco }}</span>
        <i class="icon expand" title="Full Screen"></i>
        } @if (isFullScreenMode) {
        <span class="text">{{
          "taxReturns.exit-full-screen" | transloco
        }}</span>
        <i class="icon compress" title="Exit Full Screen"></i>
        }
      </div>
    </div>
  </div>
  <app-virtual-scroller
    class="modern-table-viewport"
    (scroll)="modernTableScroll.emit($event)"
    #scroll
    [items]="rowsToDisplay"
    [enableUnequalChildrenSizes]="true"
    [useMarginInsteadOfTranslate]="true"
    [bufferAmount]=10
  >

    <table #scrollingBlock>
      <thead>
        <tr>
          <th class="row-num sticky">
            @if (subGroup.question.lockType !== 'manualInput') {
            <label
              >Table Lock Status: @if ( subGroup.question.lockType ===
              'softLock' && isTableLocked ) {
              <i class="lock icon" (click)="toggleTableLock()"></i>
              } @if ( subGroup.question.lockType === 'hardLock' && isTableLocked
              ) {
              <i
                class="lock icon"
                (click)="toggleTableLock()"
                [ngClass]="{ disabled: !isSuperAdmin }"
              ></i>
              } @if ( subGroup.question.lockType === 'softLock' &&
              !isTableLocked ) {
              <i class="unlock icon" (click)="toggleTableLock()"></i>
              } @if ( subGroup.question.lockType === 'hardLock' &&
              !isTableLocked ) {
              <i
                class="unlock icon"
                (click)="toggleTableLock()"
                [ngClass]="{ disabled: !isSuperAdmin }"
              ></i>
              }</label
            >
            }
          </th>
          @for (question of columnOrderingFiltered; track question; let i =
          $index) { @if (!question.hidden && !question.toggleOff) {
          <th
            title="{{ question?.question }}"
            [ngClass]="{
              highlight: question?.id === inputQuestionId,
              disabled: debugMode && question.actualHidden,
              tableLocked: isTableLocked
            }"
            (mouseover)="hoveredIndex = i"
            (mouseleave)="hoveredIndex = null"
          >
            @if (question?.mandatory) {
            <span class="column-mandatory" title="This column is mandatory"
              >*</span
            >
            } @if (question?.debugLinks) {
            <span>{{ question?.id }} </span>
            }
            <div class="text-ellipsis">
              {{ question?.question }}@if (question?.hint) {
              <sup title="{{ question?.hint }}"> ⓘ</sup>
              } @if (hoveredIndex === i) { @if (question.lockType === 'softLock'
              && isLocked[i]) {
              <i class="lock icon" (click)="toggleLock(i)"></i>
              } @if (question.lockType === 'hardLock' && isLocked[i]) {
              <i
                class="lock icon"
                [ngClass]="{ disabled: !isSuperAdmin }"
                (click)="toggleLock(i)"
              ></i>
              } @if (question.lockType === 'softLock' && !isLocked[i]) {
              <i class="unlock icon" (click)="toggleLock(i)"></i>
              } @if (question.lockType === 'hardLock' && !isLocked[i]) {
              <i
                class="unlock icon"
                [ngClass]="{ disabled: !isSuperAdmin }"
                (click)="toggleLock(i)"
              ></i>
              } }
            </div>
            @if (question?.showTag) {
            <span>
              {{ "taxReturns.tag" | transloco }}
              {{ question?.showTag }})</span
            >
            } @if (question?.debugLinks) {
            <span>
              {{ "taxReturns.link" | transloco }}
              <span
                class="link"
                (click)="
                  $event.stopImmediatePropagation();
                  goToSection('questions', question.id)
                "
              >
                {{ "taxReturns.question" | transloco }}</span
              >
              -
              <span
                class="link"
                (click)="
                  $event.stopImmediatePropagation();
                  goToSection('calculations', question.id)
                "
                >{{ "taxReturns.calc" | transloco }}</span
              >
              )
            </span>
            }
          </th>
          } }
        </tr>
      </thead>
      <tbody #container [ngClass]="{ tableLocked: isTableLocked }">
      @for (rowAnswer of scroll.viewPortItems; track rowAnswer) {
        <tr
          app-modern-table-row
          class="question-row"
          [ngClass]="{ active: subGroup.activeRow === rowAnswer.ordinal }"
          [rowAnswer]="rowAnswer"
          [deleted]="deleted"
          [inspectMode]="inspectMode"
          [subGroup]="subGroup"
          [formGroup]="formGroup"
          [groupId]="groupId"
          [rowIndex]="rowAnswer.ordinal"
          [readonly]="readonly"
          [readonlyGlobal]="readonlyGlobal"
          [isSelected]="subGroup.activeRow === rowAnswer.ordinal"
          [hideClearOverRideQuestionIcon]="hideClearOverRideQuestionIcon"
          [columnOrdering]="columnOrdering"
          [isLocked]="isLocked"
          [hoveredIndex]="hoveredIndex"
          (hover)="hoveredIndex = $event"
          (leave)="hoveredIndex = null"
          (loadTrace)="loadTrace.emit($event)"
          (selectRow)="selectRow.emit($event)"
          (refreshTaxReturn)="refreshTaxReturn.emit(true)"
          id="question-table-tr-{{ rowAnswer.ordinal + 1 }}"
        ></tr>
      }
      </tbody>
    </table>
  </app-virtual-scroller>
  @if (filterRules.length > 0) {
  <div class="filters-applied-message">
    {{ "taxReturns.filters-matching" | transloco }} {{ rowsToDisplay.length }} /
    {{ subGroup.rows.length }} {{ "taxReturns.rows" | transloco }}
  </div>
  } @if (!subGroup.rows || subGroup.rows?.length <= 0) {
  <div class="empty-message">
    {{ "taxReturns.there-is-no-data-in-this-table" | transloco }}
  </div>
  }
</div>

<div #tableFilterModal id="table-filter-modal" class="ui tiny modal">
  <div class="icon modal-close close"></div>

  <h1>{{ "taxReturns.filter" | transloco }}</h1>

  <div id="container">
    <div class="filter-rules">
      @for (rule of editableFilterRuleListing; track rule; let ruleIndex =
      $index) {
      <div
        class="filter-rule"
        (click)="selectFilter(ruleIndex)"
        [delayClickOutsideInit]="true"
        (clickOutside)="unselectFilter(ruleIndex)"
        [ngClass]="{
          hasErrors: rule.hasErrors,
          clickable: editableFilterIndex !== ruleIndex
        }"
      >
        <div class="icon-text-action" (click)="removeFilter(ruleIndex)">
          <div class="icon remove-circle" title="Remove filter"></div>
        </div>
        @if (editableFilterIndex !== ruleIndex) {
        <div class="filter-column read-only">
          <span
            [ngClass]="{ cta: !questionsById[rule.column.value]?.question }"
            >{{
              questionsById[rule.column.value]?.question || "Select column..."
            }}</span
          >
        </div>
        <div class="filter-operator read-only">
          <span [ngClass]="{ cta: !filtersById[rule.operator.value]?.name }">{{
            filtersById[rule.operator.value]?.name || "Select operator..."
          }}</span>
        </div>
        <div class="filter-value read-only">
          <span [ngClass]="{ cta: !displayValueForFilter(ruleIndex) }">
            {{
              questionsById[rule.column.value]
                ? "'" + displayValueForFilter(ruleIndex) + "'"
                : "Enter
                                  criteria..."
            }}</span
          >
        </div>
        } @if (editableFilterIndex === ruleIndex) {
        <div class="filter-column">
          <select
            class="ui search dropdown"
            [formControl]="rule.column"
            (change)="updateValueInputForFilter(ruleIndex)"
            required
          >
            <option value="" disabled selected hidden>{{
              "taxReturns.select-column" | transloco
            }}</option>
            @for (columnQuestion of columnQuestions; track columnQuestion) {
            <option [value]="columnQuestion.id">{{
              columnQuestion.question
            }}</option>
            }
          </select>
        </div>
        <div class="filter-operator">
          <select
            class="ui search dropdown"
            [formControl]="rule.operator"
            required
          >
            <option value="" disabled selected hidden>{{
              "taxReturns.select-operator" | transloco
            }}</option>
            @for (operator of filterOperators; track operator) {
            <option [value]="operator.id">{{ operator.name }}</option>
            }
          </select>
        </div>
        <div
          class="filter-value"
          [ngClass]="{
            'read-only': !rule.formGroup.controls[rule.column.value]
          }"
        >
          @if (rule.formGroup.controls[rule.column.value]) {
          <app-form-field-wrapper
            [formGroup]="rule.formGroup"
            [question]="this.questionsById[rule.column.value]"
          ></app-form-field-wrapper>
          } @if (!rule.formGroup.controls[rule.column.value]) {
          <span class="cta">{{
            "taxReturns.select-a-column-first" | transloco
          }}</span>
          }
        </div>
        }
      </div>
      }
      <div class="add-filter-rule clickable" (click)="addFilter()">
        <div class="icon-text-action">
          <div class="icon add-circle" title="Add filter"></div>
        </div>
        <div class="read-only">{{ "taxReturns.add-filter" | transloco }}</div>
      </div>
    </div>

    @if (hasErrors) {
    <div class="hasErrors">
      {{
        "taxReturns.cannot-apply-changes-due-to-invalid-filter-s-please-review-the-filters"
          | transloco
      }}
    </div>
    }

    <div>
      <div class="action-buttons">
        <div class="action-buttons-left">
          <div class="ui button primary outlined" (click)="resetFilter()">
            {{ "taxReturns.reset" | transloco }}
          </div>
        </div>

        <div class="actions">
          <div class="ui button primary" (click)="applyFilter()">
            {{ "taxReturns.apply" | transloco }}
          </div>
          <div class="ui button primary outlined cancel">
            {{ "taxReturns.cancel" | transloco }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
